
import Component, { mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import Mixin from '../../mixin'
import { db } from '../../main'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
import axios from 'axios'

@Component
export default class DeleteUser extends mixins(Mixin) {
  @Prop() user
  dialog_delete_user = false

  async deleteUser() {
    this.showNotification(
      'loading',
      'Procesando',
      'Eliminando a ' + this.user.names + ' . Un momento por favor.',
      0
    )
    console.log(this.user['customerID']);
    
    this.dialog_delete_user = false
    const url = URL_CLOUD_FUNCTIONS + 'deleteUser'
    const body = {
      customerID: this.user['customerID'],
      uid: this.user.uid,
      type: 'USER'
    }
    try {
      const res = await axios.post(url, body)
      console.log(res)
      this.showNotification('success', 'Éxito', 'Usuario Eliminado')
      return res
    } catch (error) {
      console.log(error)
      this.showNotification(
        'fail',
        'Error',
        'Ocurrió un error al eliminar el usuario'
      )
   }
  }
}
